module.exports = __webpack_public_path__ + "img/message.d693adb.png";